module.exports = __webpack_public_path__ + "static/img/duofangguangbo.28fe0c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/duofangguangbo.png
// module id = 0odP
// module chunks = 24